import { format } from 'src/utils/dateOperations/date-fns';
export default function dateToISODate(date) {
    return format(date, 'yyyy-MM-dd');
}
